import { NgModule } from 'ng-metadata/core';
import {ChangeLangService} from './changeLang.service';
import {PrmChangeLang} from './changeLang.directive';

@NgModule({
    declarations: [
        PrmChangeLang
    ],
    providers: [
        ChangeLangService

    ],
    imports:[

    ]
})

export class ChangeLangModule{}


// WEBPACK FOOTER //
// ./src/main/webapp/components/infra/lang/changeLang.module.ts